import { datadogRum } from '@datadog/browser-rum';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import App from './App';
import environment from './environment';
import Fallback from './layout/FallBack';
import reportWebVitals from './reportWebVitals';

const {
  ADMINIFI_URL,
  CERTIFICATE_SERVICE_URL,
  CONTENT_SERVICE_URL,
  COMPLIANCE_URL,
  DASHIFI_URL,
  DATADOG_APPLICATION_ID,
  DATADOG_CLIENT_TOKEN,
  EVALUFI_URL,
  GOOGLE_TAG_MANAGER_ID,
  NOTIFI_URL,
  STAGE,
  VERSION,
  DISABLE_TELEMETRY,
} = environment;

if (!DISABLE_TELEMETRY) {
  if (GOOGLE_TAG_MANAGER_ID) {
    TagManager.initialize({
      gtmId: GOOGLE_TAG_MANAGER_ID,
      dataLayerName: 'globalDataLayer',
    });
  }

  if (DATADOG_APPLICATION_ID) {
    datadogRum.init({
      allowedTracingUrls: [
        ADMINIFI_URL,
        CERTIFICATE_SERVICE_URL,
        CONTENT_SERVICE_URL,
        COMPLIANCE_URL,
        DASHIFI_URL,
        EVALUFI_URL,
        NOTIFI_URL,
      ],
      applicationId: DATADOG_APPLICATION_ID,
      clientToken: DATADOG_CLIENT_TOKEN,
      env: STAGE,
      sessionSampleRate: 100,
      service: 'dashifi',
      sessionReplaySampleRate: 100, // if not included, the default is 100
      site: 'datadoghq.com',
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      trackSessionAcrossSubdomains: true,
      version: VERSION,
    });
  }
}

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Suspense fallback={<Fallback />}>
      <App />
    </Suspense>
    {STAGE !== 'production' && <div style={{ display: 'none' }}>{`version: ${VERSION}`}</div>}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
